import type { KanbanAgent } from '@ts-tutor-kanban/interfaces'

import { useTasksKanbanStore } from '@stores/tasks-kanban'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { getAxiosErrorMessage } from '@helpers/axios'

import { useToast } from '@UI/Toast/ToastProvider'

export const useTasksKanbanAgentsApi = async (): Promise<KanbanAgent[]> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.agents')

  const tasksKanbanStore = useTasksKanbanStore()

  try {
    const { data } = await $axios.get(url!)
    const agents: KanbanAgent[] = data.data.agents

    tasksKanbanStore.setAgents(agents)

    return agents
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))

    return []
  }
}